module.exports = __webpack_public_path__ + "static/media/bind-course.0e6480c1.jpg";